<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="500")
  yz-card
    yz-dialog-normal-header(title="Change location?" @close="handleCancel")
    yz-dialog-normal-content.px-6.py-4
      .yz-regular-body-sm.text-neutral-700 Changing the location will reset all selected items. This action cannot be undone.
    yz-dialog-normal-actions(save-label="Change location" @save="handleConfirm" @cancel="handleCancel")
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur()
      }
    })
  },
  methods: {
    handleCancel () {
      this.$emit('canceled')
      this.showDialog = false
    },
    handleConfirm () {
      this.$emit('confirmed')
    },
  },
}
</script>

<style scoped>
</style>
